import React, { useEffect, useState } from "react";
import "./AddBalance.css";

// components imports
import StripeCreditCardForm from "./StripeCreditCardForm";
import Loader from "../../../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { addBalance } from "../../../../../../../services/ShipperServices/Payments/payments.services";
import { getCardSetupIntent } from "../../../../../../../services/ShipperServices/Payments/payments.services";
// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
// import Autocomplete from "@mui/material/Autocomplete";
import { useSelector } from "react-redux";
import Upload from "@mui/icons-material/CloudUpload";
import CreditCard from "../../../../../../../assets/images/credit-card.png";
import BankTransfer from "../../../../../../../assets/images/bank-transfer.png";
import ETransfer from "../../../../../../../assets/images/e-transfer.png";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
import {
  FcNeutralTrading,
  FcReading,
  FcOrganization,
  FcCheckmark,
  FcBusinessContact,
  FcDepartment,
  FcFeedback,
  FcUnlock,
  FcAbout,
} from "react-icons/fc";
import { MdOutlineContentCopy } from "react-icons/md";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { useFormat } from "../../../../../../../i18n/format";

const initialData = {
  balance: "",
  file: null,
  payment_type: "bank_transfer",
  transaction_id: "",
};
const bankInfo = {
  bank: "The Bank of Nova Scotia",
  title: "HAJEX Inc.",
  iban: "0386618",
  transit: "12781",
  institution: "002",
};
export default function AddBalance({
  open,
  setOpen,
  setSnack,
  getAllTransactions,
}) {
  const { t } = useTranslation("finances");
  const { formatMoney } = useFormat();
  // "$500" / "500 $"
  const minimum = formatMoney(500, "CAD", { maximumFractionDigits: 0 });
  const user = useSelector((state) => state.user);

  const [data, setData] = useState(initialData);
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  const [clientSecret, setClientSecret] = useState(null); // used for stripe credit card setup
  const [activeBox, setActiveBox] = useState(1);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [eTransCopiedCode, seteTransCopiedCode] = useState(false);
  const [eTransCopiedId, seteTransCopiedId] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setActiveBox(1);
    setData(initialData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const handleNextClick = (type) => {
    type && setData({ ...data, payment_type: type });
    setActiveBox(activeBox + 1);
  };

  const handleCreditCardOptionClick = () => {
    setData({ ...data, payment_type: "card" });
    setActiveBox(4); // we will show stripe credit card form based on this option
    if (user.card_last_four != null) {
      // console.log("just charge him simply instead of asking card setup again");
      getCreditCardSetup(); // replace this later with simple charge amount and pay button as customer has already his card added
    } else {
      // card_last_four is null, so simply this means that he is first time adding/using card
      // send SetupIntent request
      getCreditCardSetup();
    }
  };

  const getCreditCardSetup = async () => {
    setLoading(true);
    let response;
    try {
      response = await getCardSetupIntent();
      setClientSecret(response.data.result.client_secret);
      // console.log("client_secret", response.data.result.client_secret);
    } catch (error) {
      console.log(error);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
    setLoading(false);
  };

  const handlePrevClick = () => {
    setActiveBox(activeBox - 1);
  };
  function handleCopy() {
    navigator.clipboard.writeText(bankInfo.iban);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  //eTrans Work start
  const eTransfer = {
    pymentId: "bolt@hajex.com",
    code: "HAJEX",
  };
  const handleClickETrans = () => {
    setActiveBox(5);
  };
  const handlehomeClick = () => {
    setActiveBox(1);
  };
  function handleETransferCopy(textToCopy, activeThis) {
    navigator.clipboard.writeText(textToCopy);
    if (activeThis === "eTransCode") {
      seteTransCopiedCode(true);
    }

    if (activeThis === "eTransId") {
      seteTransCopiedId(true);
    }
    setTimeout(() => {
      seteTransCopiedCode(false);
      seteTransCopiedId(false);
    }, 2000);
  }
  // eTrans work end

  const handleSave = async () => {
    setLoading(true);
    // for (const key in data) {
    //   if (data[key] === "") {
    //     setSnack((snack) => {
    //       return {
    //         ...snack,
    //         open: true,
    //         text: `${key} is required!`,
    //         severity: "error",
    //       };
    //     });
    //     setLoading(false);
    //     return;
    //   }
    // }

    const payload = {
      balance: data.balance,
      payment_type: data.payment_type,
      transaction_id: data.transaction_id,
      file: data.file,
    };
    const formData = new FormData();
    formData.append("balance", payload.balance);
    formData.append("transaction_id", payload.transaction_id);
    formData.append("payment_type", payload.payment_type);
    payload.file && formData.append("file", payload.file);
    const saved = await addBalance(formData);
    if (!saved.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("addBalance.creditedNotice"),
          severity: "success",
          action: {
            label: t("addBalance.viewPolicy"),
            onClick: () => setIsOpen(true),
          },
        };
      });
      getAllTransactions();
      setData(initialData);
      setLoading(false);
      handleClose();
    }
  };
  const handleFileChange = (e) => {
    setData({ ...data, file: e.target.files[0] });
  };

  const PaymentPolicyModal = () => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <div className="w-full max-w-2xl rounded-lg bg-ui-surface shadow-xl">
          {/* Header */}
          <div className="border-b px-6 py-4">
            <h2 className="text-lg font-semibold text-ui-text">
              {t("policy.title")}
            </h2>
          </div>

          {/* Body */}
          <div className="max-h-[60vh] overflow-y-auto px-6 py-4 text-sm text-ui-text space-y-4">
            <p>{t("policy.awaiting")}</p>

            <p>
              <Trans
                t={t}
                i18nKey="policy.nonRefundable"
                components={{
                  strong: <span className="font-semibold text-ui-text" />,
                  b: <span className="font-semibold" />,
                }}
              />
            </p>

            <p>
              <Trans
                t={t}
                i18nKey="policy.verified"
                components={{ b: <span className="font-semibold" /> }}
              />
            </p>

            <p>{t("policy.agree")}</p>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 border-t px-6 py-4">
            <button
              onClick={() => setIsOpen(false)}
              className="rounded-md border px-4 py-2 text-sm text-ui-text hover:bg-ui-surface-sunken"
            >
              {t("common:actions.close")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <PaymentPolicyModal />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="pmtsadd__balance_modal">
          <div className="pmtsadd__balance_modalheading">{t("addBalance.title")}</div>
          <div className="pmtsadd__balance_modalcontent">
            <div
              className={`pmtsadd__balance_modalcontentbox ${
                activeBox === 1
                  ? "pmtsadd__balance_modalcontentactivebox"
                  : activeBox > 1
                    ? "pmtsadd__balance_modalcontentboxleft"
                    : "pmtsadd__balance_modalcontentboxright"
              }`}
            >
              <div className="pmtsadd__balance_methods">
                <div
                  className="pmtsadd__balance_method"
                  onClick={handleCreditCardOptionClick}
                >
                  <div className="pmtsadd__balance_methodicon">
                    <img src={CreditCard} alt="" />
                  </div>
                  <div className="pmtsadd__balance_methodtxt">
                    {t("addBalance.card")}
                  </div>
                </div>
                <div
                  className="pmtsadd__balance_method"
                  onClick={() => handleNextClick("bank_transfer")}
                >
                  <div className="pmtsadd__balance_methodicon">
                    <img src={BankTransfer} alt="" />
                  </div>
                  <div className="pmtsadd__balance_methodtxt">
                    {t("addBalance.bank")}
                  </div>
                </div>
                <div
                  className="pmtsadd__balance_method "
                  onClick={() => handleClickETrans("e_transfer")}
                >
                  <div className="pmtsadd__balance_methodicon">
                    <img src={ETransfer} alt="" />
                  </div>
                  <div className="pmtsadd__balance_methodtxt">{t("addBalance.eTransfer")}</div>
                </div>
              </div>
            </div>
            <div
              className={`pmtsadd__balance_modalcontentbox ${
                activeBox === 2
                  ? "pmtsadd__balance_modalcontentactivebox"
                  : activeBox > 2
                    ? "pmtsadd__balance_modalcontentboxleft"
                    : "pmtsadd__balance_modalcontentboxright"
              }`}
            >
              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcReading size={25} />
                  {t("addBalance.accountTitle")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {bankInfo.title}
                </div>
              </div>
              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcBusinessContact size={25} />
                  {t("addBalance.account")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {bankInfo.iban}{" "}
                  {!copied && (
                    <span
                      className="pmtsadd__balance_modaltxtrtcopy"
                      onClick={handleCopy}
                    >
                      <MdOutlineContentCopy
                        size={22}
                        style={{ marginLeft: "10px" }}
                      />
                    </span>
                  )}
                  {copied && (
                    <span
                      className="pmtsadd__balance_modaltxtrtcopy"
                      onClick={handleCopy}
                    >
                      <FcCheckmark size={22} style={{ marginLeft: "10px" }} />
                    </span>
                  )}
                </div>
              </div>

              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcNeutralTrading size={25} />
                  {t("addBalance.transit")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {bankInfo.transit}
                </div>
              </div>
              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcOrganization size={25} />
                  {t("addBalance.institution")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {bankInfo.institution}
                </div>
              </div>

              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcDepartment size={25} /> {t("addBalance.bankName")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {bankInfo.bank}
                </div>
              </div>

              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcAbout size={25} /> {t("addBalance.note")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {t("addBalance.minAdded", { amount: minimum })}
                </div>
              </div>
              <br />
              <div className="pmtsadd__balance_modalbackbtns">
                {" "}
                <button
                  onClick={handlePrevClick}
                  className="pmtsadd__balance_modalbackbtn"
                >
                  <FaArrowAltCircleLeft size={15} color="grey" />
                  {t("common:actions.back")}
                </button>
                <button
                  onClick={(e) => handleNextClick()}
                  className="pmtsadd__balance_modalbackbtn"
                >
                  {t("common:actions.next")}
                  <FaArrowAltCircleRight
                    size={15}
                    color="grey"
                    style={{ marginRight: 0 }}
                  />
                </button>
              </div>
            </div>
            <div
              className={`pmtsadd__balance_modalcontentbox ${
                activeBox === 3
                  ? "pmtsadd__balance_modalcontentactivebox"
                  : activeBox > 3
                    ? "pmtsadd__balance_modalcontentboxleft"
                    : "pmtsadd__balance_modalcontentboxright"
              }`}
            >
              <div className="pmtsadd__balance_modalrow">
                <div className="pmtsadd__balance_modalinputwrap">
                  <input
                    className="pmtsadd__balance_modalinput"
                    placeholder={t("addBalance.paidAmount")}
                    name="balance"
                    value={data.balance}
                    onChange={handleChange}
                    type="number"
                  />
                </div>
              </div>
              <div className="pmtsadd__balance_modalrow">
                <div className="pmtsadd__balance_modalinputwrap">
                  <input
                    className="pmtsadd__balance_modalinput"
                    placeholder={t("columns.transactionId")}
                    name="transaction_id"
                    value={data.transaction_id}
                    onChange={handleChange}
                    type="text"
                  />
                </div>
              </div>
              <div className="pmtsadd__balance_modalrow">
                <div className="pmtsadd__balance_modalinputwrap">
                  <label className="pmtsadd__balance_profimagelbl">
                    <Upload /> {data.file?.name ?? t("addBalance.uploadReceipt")}
                    <input
                      type="file"
                      size="60"
                      className="pmtsadd__balance_profimageinput"
                      onChange={handleFileChange}
                      accept=".jpg,.png"
                    />
                  </label>
                </div>
              </div>
              <button
                onClick={handlePrevClick}
                className="pmtsadd__balance_modalbackbtn"
              >
                <FaArrowAltCircleLeft size={15} color="grey" />
                {t("common:actions.back")}
              </button>
            </div>
            <div
              className={`pmtsadd__balance_modalcontentbox ${
                activeBox === 4
                  ? "pmtsadd__balance_modalcontentactivebox"
                  : activeBox > 4
                    ? "pmtsadd__balance_modalcontentboxleft"
                    : "pmtsadd__balance_modalcontentboxright"
              }`}
            >
              <div style={{ width: "100%", minHeight: "fit-content" }}>
                {activeBox === 4 && stripePromise && clientSecret && (
                  <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <StripeCreditCardForm
                      setOpen={setOpen}
                      setSnack={setSnack}
                      setActiveBox={setActiveBox}
                      getAllTransactions={getAllTransactions}
                    />
                  </Elements>
                )}
                {activeBox === 4 && clientSecret == null && (
                  <h4 style={{ color: "blue", marginBottom: "40px" }}>
                    {t("addBalance.loadingPayment")}{" "}
                  </h4>
                )}
              </div>
            </div>

            <div
              className={`pmtsadd__balance_modalcontentbox ${
                activeBox === 5
                  ? "pmtsadd__balance_modalcontentactivebox"
                  : activeBox > 5
                    ? "pmtsadd__balance_modalcontentboxleft"
                    : "pmtsadd__balance_modalcontentboxright"
              }`}
            >
              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcFeedback size={25} />
                  {t("addBalance.id")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {eTransfer.pymentId}{" "}
                  {!eTransCopiedId && (
                    <span
                      className="pmtsadd__balance_modaltxtrtcopy"
                      onClick={() =>
                        handleETransferCopy(eTransfer.pymentId, "eTransId")
                      }
                    >
                      <MdOutlineContentCopy
                        size={22}
                        style={{ marginLeft: "10px" }}
                      />
                    </span>
                  )}
                  {eTransCopiedId && (
                    <span
                      className="pmtsadd__balance_modaltxtrtcopy"
                      onClick={() =>
                        handleETransferCopy(eTransfer.pymentId, "eTransId")
                      }
                    >
                      <FcCheckmark size={22} style={{ marginLeft: "10px" }} />
                    </span>
                  )}
                </div>
              </div>
              <br />
              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcUnlock size={25} />
                  {t("addBalance.code")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {eTransfer.code}{" "}
                  {!eTransCopiedCode && (
                    <span
                      className="pmtsadd__balance_modaltxtrtcopy"
                      onClick={() =>
                        handleETransferCopy(eTransfer.code, "eTransCode")
                      }
                    >
                      <MdOutlineContentCopy
                        size={22}
                        style={{ marginLeft: "10px" }}
                      />
                    </span>
                  )}
                  {eTransCopiedCode && (
                    <span
                      className="pmtsadd__balance_modaltxtrtcopy"
                      onClick={() =>
                        handleETransferCopy(eTransfer.code, "eTransCode")
                      }
                    >
                      <FcCheckmark size={22} style={{ marginLeft: "10px" }} />
                    </span>
                  )}
                </div>
              </div>
              <div className="pmtsadd__balance_modaltxtrow">
                <div className="pmtsadd__balance_modaltxtlft">
                  <FcAbout size={25} /> {t("addBalance.note")}
                </div>
                <div className="pmtsadd__balance_modaltxtrt">
                  {t("addBalance.minSent", { amount: minimum })}
                </div>
              </div>
              <br />
              <div className="pmtsadd__balance_modalbackbtns">
                {" "}
                <button
                  onClick={handlehomeClick}
                  className="pmtsadd__balance_modalbackbtn"
                >
                  <FaArrowAltCircleLeft size={15} color="grey" />
                  {t("common:actions.back")}
                </button>
              </div>
            </div>
          </div>
          <div className="pmtsadd__balance_modalfooter">
            <div className="pmtsadd__balance_modalcncl" onClick={handleClose}>
              {t("common:actions.cancel")}
            </div>
            {activeBox <= 3 && (
              <div
                className={`pmtsadd__balance_modalsave ${
                  (!(
                    activeBox <= 3 &&
                    data.balance != "" &&
                    data.transaction_id != "" &&
                    data.file != null
                  ) ||
                    activeBox == 4) &&
                  "pmtsadd__balance_modalsavedisabled"
                }`}
                onClick={handleSave}
              >
                {loading ? <Loader /> : t("common:actions.save")}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
